<template>
  <div :style="{ width: '180px' }" class="page_left">
    <el-menu :default-active="onRoutes" :router="true" class="el-menu-vertical-demo" background-color="#131E57" text-color="#999999" active-text-color="#fff" @select="selectIn" unique-opened>
      <template v-for="(item, index) in menuList">
        <el-submenu :index="item.route" :key="index" v-if="item.child && item.child.length != 0 && item.child[0].type == 1">
          <template slot="title">
            <i :class="'iconfont ' + item.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <el-menu-item :index="v.route" v-for="(v, i) in item.child" :key="i">{{ v.name }}</el-menu-item>
        </el-submenu>
        <el-menu-item v-else :index="item.route" :key="index">
          <i :class="'iconfont ' + item.icon"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "sAside",
  data() {
    return {
      menuList: [
        {
          route: "/home/account",
          name: "账户信息",
          icon: "icon-icon-1",
        },

        // {
        //   route: "/home/viewData",
        //   name: "数据统计",
        //   icon: "icon-shuju",
        //   children: [
        //     {
        //       route: "/home/viewData",
        //       name: "数据统计",
        //     },
        //     {
        //       route: "/home/tickets-data",
        //       name: "门票数据",
        //     }
        //   ]
        // },
        // {
        //   route: "/home/shopManage",
        //   name: "店铺管理",
        //   icon: "icon-dianpu",
        //   children: [
        //     {
        //       route: "/home/shopManage",
        //       name: "店铺管理",
        //     },
        //     {
        //       route: "/home/fixShopList",
        //       name: "店铺装修",
        //     },
        //   ],
        // },
        // {
        //   route: "/home/commodity",
        //   name: "商品管理",
        //   icon: "icon-shoppingcart",
        //   children: [
        //     {
        //       route: "/home/commodity",
        //       name: "商品中心",
        //     },
        //     {
        //       route: "/home/activityGoods",
        //       name: "活动商品",
        //     },
        //     {
        //       route: "/home/application",
        //       name: "营销玩法",
        //     },
        //     {
        //       route: "/home/qualityControl",
        //       name: "品控商品一览",
        //     },
        //     {
        //       route: "/home/trade",
        //       name: "交易量统计",
        //     },
        //     {
        //       route: "/home/pageView",
        //       name: "访问量统计",
        //     },
        //   ],
        // },
        // {
        //   route: "/home/orders",
        //   name: "订单管理",
        //   icon: "icon-dingdan",
        //   children: [
        //     {
        //       route: "/home/orders",
        //       name: "商城订单",
        //     },
        //      {
        //       route: "/home/refundList",
        //       name: "退款订单",
        //     },
        //     {
        //       route: "/home/returnedPurchase",
        //       name: "退货订单",
        //     },
        //     {
        //       route: "/home/logisticsOrder",
        //       name: "物流订单",
        //     },
        //     {
        //       route: "/home/baby-paradise",
        //       name: "亲子项目订单",
        //     },

        //   ],
        // },
        /*  {
           route: "/home/refund",
           name: "退款退货",
           icon: "icon-shouhou",
         }, */
        /*   {
            route: "/home/role",
            name: "权限管理",
            icon: "icon-fangkuai",
            children: [
              {
                route: "/home/role",
                name: "角色管理",
              },
              {
                route: "/home/accountMember",
                name: "账号管理",
              },
            ],
          }, */

        //   {
        //     route: "/home/viewData",
        //     name: "数据统计",
        //     icon: "icon-shuju",
        //   },
        //   {
        //     route: "/home/shopManage",
        //     name: "店铺管理",
        //     icon: "icon-dianpu",
        //     children: [
        //       {
        //         route: "/home/shopManage",
        //         name: "店铺管理",
        //       },
        //       {
        //         route: "/home/fixShopList",
        //         name: "店铺装修",
        //       },
        //       {
        //         route: "/home/storeConfig",
        //         name: "店铺交易配置",
        //       },
        //     ],
        //   },
        //     {
        //     route: "/home/shortMessageHistory",
        //     name: "消息管理",
        //     icon: "icon-shuju",
        //      children: [
        //       {
        //         route: "/home/shortMessageHistory",
        //         name: "消息中心",
        //       },]
        //   },
        //   {
        //     route: "/home/commodity",
        //     name: "商品管理",
        //     icon: "icon-shoppingcart",
        //     children: [
        //       {
        //         route: "/home/commodity",
        //         name: "商品中心",
        //       },
        //       {
        //         route: "/home/activityGoods",
        //         name: "活动商品",
        //       },
        //       {
        //         route: "/home/application",
        //         name: "营销玩法",
        //       },
        //       {
        //         route: "/home/qualityControl",
        //         name: "品控商品一览",
        //       },
        //       {
        //         route: "/home/trade",
        //         name: "交易量统计",
        //       },
        //       {
        //         route: "/home/pageView",
        //         name: "访问量统计",
        //       },
        //     ],
        //   },
        //   {
        //     route: "/home/Content",
        //     name: "内容管理",
        //     icon: "icon-dingdan",
        //     children: [
        //       {
        //         route: "/home/Content",
        //         name: "素材中心",
        //       }
        //     ],
        //   },
        //   {
        //     route: "/home/orders",
        //     name: "订单管理",
        //     icon: "icon-dingdan",
        //     children: [
        //       {
        //         route: "/home/orders",
        //         name: "商城订单",
        //       },
        //        {
        //         route: "/home/refundList",
        //         name: "退款订单",
        //       },
        //       {
        //         route: "/home/returnedPurchase",
        //         name: "退货订单",
        //       },
        //       {
        //         route: "/home/logisticsOrder",
        //         name: "物流订单",
        //       },
        //     /*   {
        //         route: "/home/depositOrder",
        //         name: "店铺资金订单",
        //       } */
        //     ],
        //   },
        //   /*  {
        //      route: "/home/refund",
        //      name: "退款退货",
        //      icon: "icon-shouhou",
        //    }, */

        //   /*   {
        //         route: "/home/withdrawal",
        //         name: "提现管理",
        //         icon: "icon-qiyetixian",
        //     }, */
        //  /*  {
        //     route: "/home/coupon",
        //     name: "券列表",
        //     icon: "icon-kaquan",
        //   }, */
        //   {
        //     route: "/home/activity",
        //     name: "活动运营",
        //     icon: "icon-yunying",
        //     children: [
        //       {
        //         route: "/home/activity",
        //         name: "活动运营",
        //         icon: "icon-yunying",
        //       },
        //       {
        //         route: "/home/poster",
        //         name: "邮寄列表",
        //         icon: "icon-yunying",
        //       },
        //     ],
        //   },
        //   {
        //     route: "/home/marketingManagement",
        //     name: "品牌保护",
        //     icon: "icon--pinpaiguanli",
        //     children: [
        //       {
        //         route: "/home/marketingManagement",
        //         name: "经销商管理",
        //       },
        //       {
        //         route: "/home/productManagement",
        //         name: "产品管理",
        //       },
        //       {
        //         route: "/home/propertyManagement",
        //         name: "产权管理",
        //       },
        //       // {
        //       //     route: "/home/installSale",
        //       //     name: "安装售后",
        //       // },
        //       {
        //         route: "/home/violation",
        //         name: "违规监控",
        //       },
        //       {
        //         route: "/home/infringement",
        //         name: "侵权监控",
        //       },

        // {
        //   route: "/home/violationWarn",
        //   name: "价格保护",
        //   icon: "icon-jiageyuce",
        //   children: [
        //     {
        //       route: "/home/priceWarn",
        //       name: "价格预警",
        //     },
        //     {
        //       route: "/home/quickPriceWarn",
        //       name: "快速价格预警",
        //     },
        //     // {
        //     //     route: "/home/violationWarn",
        //     //     name: "违规预警",
        //     // },
        //     {
        //       route: "/home/marketWarn",
        //       name: "市场预警",
        //     },
        //   ],
        // },
        // {
        //         route: "/home/monitor",
        //         name: "价格监测",
        //         icon: "icon-jiankong",
        //         children: [
        //             {
        //                 route: "/home/monitor",
        //                 name: "价格监测",
        //             },
        //             {
        //                 route: "/home/peiceAlert",
        //                 name: "价格预警",
        //             },
        //         ],
        //     },

        // {
        //   route: "/home/erweimaactive",
        //   name: "优客码",
        //   icon: "icon-erweima_o",
        //   children: [
        //     {
        //       route: "/home/erweimaactive",
        //       name: "活动发布",
        //     },
        //     {
        //       route: "/home/activemanage",
        //       name: "激活管理",
        //     },
        //     {
        //       route: "/home/erweimaorder",
        //       name: "订单管理",
        //     },
        //     {
        //       route: "/home/messagetip",
        //       name: "消息管理",
        //     },
        //   ],
        // },
        // {
        //      route: "/home/application",
        //      name: "应用中心",
        //      icon: "icon-yingyongzhongxin",
        //      children: [
        //          {
        //              route: "/home/detection",
        //              name: "检测套餐",
        //          },
        //          {
        //              route: "/home/bill",
        //              name: "账单中心",
        //          },
        //      ],
        // },
        // {
        //   route: "/home/cardManage",
        //   name: "福利卡",
        //   icon: "icon-fuliquan",
        // },
        // {
        //   route: "/home/Address",
        //   name: "地址列表",
        //   icon: "icon-erweima_o",
        //   children: [
        //     {
        //       route: "/home/Address",
        //       name: "地址列表",
        //     },
        //   ],
        // },
        // {
        //     route: "/home/tickets-data",
        //     name: "数据分析",
        //     icon: "icon-erweima_o",
        //     children: [
        //         {
        //             route: "/home/tickets-data",
        //             name: "门票数据",
        //         },
        //     ],
        // },
        // {
        //     route: "/home/auditManage",
        //     name: "审核管理",
        //     icon: "icon-erweima_o",
        //     children: [
        //         {
        //             route: "/home/baby-ticket-manage",
        //             name: "亲子票务管理",
        //         },
        //     ],
        // },
        // {
        //   route: "/home/writeOffManage",
        //   name: "核销管理",
        //   icon: "icon-erweima_o",
        //   children: [
        //     {
        //       route: "/home/i-want-write",
        //       name: "我要核销",
        //     },
        //     {
        //       route: "/home/write-record",
        //       name: "核销记录"
        //     }
        //   ]
        // },
        // {
        //     route: "/home/feature",
        //     name: "功能设置",
        //     icon: "icon-erweima_o",
        //     children: [
        //         {
        //             route: "/home/feature-calendar",
        //             name: "预约日历",
        //         },
        //     ],
        // },
      ],
    };
  },
  mounted() {
    this.getloginMenu();
  },
  computed: {
    onRoutes() {
      return this.$route.path;
    },
  },
  methods: {
    ...mapActions({
      loginMenu: "pressimApi/loginMenu",
    }),
    ...mapMutations({
      setTitles: "setTitles",
    }),
    selectIn(index, indexPath) {
      if (index == null) {
        this.$message.error("菜单权限配置异常，请联系开发人员");
      } else {
        for (let i = 0; i < this.menuList.length; i++) {
          if (this.menuList[i].route == index) {
            this.setTitles(this.menuList[i].name);
          }
        }
      }
    },
    getloginMenu() {
      this.loginMenu({ token: this.$store.state.token })
        .then((res) => {
          if (res.code == 1) {
            let arr = [];
            // try {
            res.data.map((el) => {
              let exception1 = 0;
              let exception2 = 0;
              // try {
              if (el.type === 1) {
                el.configure = eval("(" + el.configure + ")");
                el.route = el.configure.route;
                el.icon = el.configure.icon;
                if (el.child && el.type !== 2) {
                  el.child.map((item) => {
                    // try {
                      if (item.type <= 1) {
                        return (item.route = eval("(" + item.configure + ")"));
                      }
                    // } catch (exception) {
                    //   exception1 = 1;
                    //   console.log("object :>> ", el);
                    //   this.$message.error({ message: `缺少${el.name}菜单,请联系开发人员`, duration: 3000 });
                    // }
                  });
                }
                // } catch (exception) {
                //   exception2 = 2;
                //   this.$message.error({ message: `缺少${el.name}菜单,请联系开发人员`, duration: 3000 });
                // }
                // if (exception1 == 0 && exception2 == 0)
                arr.push(el);
              }
            });
            this.menuList = this.menuList.concat(arr);
            // } catch (error) {
            //   //  this.$message.error(error)
            // }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-submenu .el-menu-item {
  min-width: auto !important;
}
::v-deep .el-submenu__title {
  i.iconfont {
    font-size: 20px;
    margin-right: 8px;
  }
}
::v-deep .el-menu {
  border-right: none !important;
}
::v-deep .el-menu-item.is-active {
  background-color: #2448ff !important;
}
.page_left {
  &::-webkit-scrollbar {
    display: none !important;
  }
  flex-shrink: 0;
  min-height: calc(100vh - 64px);
  height: calc(100vh - 64px);
  background: none repeat scroll 0 0 #131e57;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  transition: width 0.28s;
  overflow-y: auto;
  // ::v-deep .el-menu{
  //   border-right: none;
  //   .el-menu-item{
  //     background-color:#1d1e23;
  //     &.collapse{
  //       width: 64px;
  //     }
  //     .iconfont {
  //       font-size: 22px;
  //       margin: 5px;
  //     }
  //     &.is-active{
  //       background-color: #101117;
  //     }
  //     &:hover{
  //       background-color: #101117;
  //     }
  //   }
  // }
  .el-menu-item {
    i {
      font-size: 20px;
      margin-right: 8px;
    }
  }
}
</style>
